import classNames from 'classnames'
import { memo, useCallback, useMemo } from 'react'
import { useShallow } from 'zustand/react/shallow'
import { useTranslate } from '../../../../../hooks/language/use-translate'
import { useGlobalStore } from '../../../../../store/global-store'

const ExperienceToEarn = memo(() => {
  const { isLuck, giftSelectedValue, quantity } = useGlobalStore(
    useShallow((state) => ({
      isLuck: state?.selectedType?.isLuck,
      quantity: state.quantity,
      giftSelectedValue: state?.giftSelected?.value,
    })),
  )

  if (giftSelectedValue) {
    const divider = isLuck ? 10 : 1

    return (
      <span className="text-xs font-bold text-white">
        +{(giftSelectedValue * quantity) / divider} XP
      </span>
    )
  }
})

export function TotalValue() {
  const { giftSelected, quantity, usersToGift } = useGlobalStore(
    useShallow((state) => ({
      giftSelected: state.giftSelected,
      quantity: state.quantity,
      usersToGift: state.usersToGift,
    })),
  )

  const { translate } = useTranslate()

  const changeQuantity = useCallback((quantity: number) => {
    useGlobalStore.setState({ quantity })
  }, [])

  const combos: number[] = useMemo(() => {
    if (giftSelected?.allowedCombos) {
      return JSON.parse(giftSelected?.allowedCombos)
    }
  }, [giftSelected])

  const disabled = useMemo(
    () => !quantity || !usersToGift?.size,
    [quantity, usersToGift?.size],
  )

  const handleOpenModalCoinDrop = useCallback(() => {
    if ('ReactNativeWebView' in window) {
      // @ts-ignore
      window.ReactNativeWebView.postMessage('open-modal-coin-drop')
    }
  }, [])

  function handleClickSend() {
    if ('ReactNativeWebView' in window) {
      const giftSelected = useGlobalStore.getState().giftSelected

      if (giftSelected?.isCoinDrop) {
        return handleOpenModalCoinDrop()
      }

      const usersToGift = useGlobalStore.getState().usersToGift
      const quantity = useGlobalStore.getState().quantity
      const selectedType = useGlobalStore.getState().selectedType

      // @ts-ignore
      window.ReactNativeWebView.postMessage(
        JSON.stringify({
          giftSelected,
          usersToGift: [...usersToGift],
          quantity,
          selectedType,
        }),
      )
    }
  }

  return (
    <div className="flex flex-row gap-5 p-4 items-center justify-end border-t ">
      <div className="flex flex-row text-gray-400 flex-1 rounded-sm overflow-hidden ">
        {(combos ?? []).map((combo) => (
          <button
            key={combo}
            type="button"
            onClick={() => changeQuantity(combo)}
            className={classNames(['text-sm w-8 text-white bg-[#151515]'], {
              ' bg-gray-700 text-gray-600 text-gray-400': quantity === combo,
              'bg-linear-to-r from-[#151515] to-[#151515]': quantity !== combo,
            })}
          >
            {combo}
          </button>
        ))}
      </div>

      <div className="space-x-2">
        <ExperienceToEarn />

        <button
          type="button"
          disabled={disabled}
          className={classNames(
            'text-black py-2 px-3 rounded-md text-sm font-bold',
            {
              'bg-linear-to-r from-gray-400 to-gray-700': !disabled,
              'bg-linear-to-r from-gray-100 to-gray-100': disabled,
            },
          )}
          onClick={handleClickSend}
        >
          {translate('modal-gifts-send')}
        </button>
      </div>
    </div>
  )
}
